import React from 'react'

type EditableTextProps = {
  placeholder?: string
  value: string
  onChange: (value: string) => void
  editable?: boolean
  updateEditMode: (boolean: any) => void
  isParagraph?: boolean
  rows?: number
  cols?: number
  autoFocus?: boolean
  className?: string
}

export default function EditableText(props: EditableTextProps) {
  const {placeholder, value, onChange, editable, updateEditMode, isParagraph, rows, cols, autoFocus, className} = props

  return (
    <React.Fragment>
      <React.Fragment>
        {isParagraph ? (
          <textarea
            rows={rows || 6}
            cols={cols || 62}
            style={{cursor: !editable ? 'none' : 'pointer', pointerEvents: editable ? undefined : 'none'}}
            className={className}
            value={value}
            placeholder={placeholder}
            onClick={() => updateEditMode(true)}
            onChange={(event) => {
              onChange(event.target?.value ?? '')
            }}
            wrap="hard"
          />
        ) : (
          <input
            style={{cursor: !editable ? 'none' : 'pointer', pointerEvents: editable ? undefined : 'none'}}
            className={className}
            autoFocus={autoFocus}
            type="text"
            value={value}
            placeholder={placeholder}
            onClick={() => updateEditMode(true)}
            onChange={(event) => {
              onChange(event.target?.value ?? '')
            }}
          />
        )}
      </React.Fragment>
    </React.Fragment>
  )
}
